(ns kyber.styles.base)

(defn resets
  [gs]
  {"html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video" {:margin 0
                           :padding 0
                           :border 0
                           :font-size "100%"
                           :font :inherit
                           :vertical-align :baseline}
   "article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section" {:display :block}
   "body" {:line-height 1}
   "ol, ul" {:list-style :none
             :font-family (gs [:font-family :open-sans])
             :color (gs [:colors :gray-scale-500])
             :font-size (gs [:font-size :body-20])}
   "blockquote, q" {:quotes :none}
   "blockquote:before, blockquote:after, q:before, q:after" {:content :none}
   "table" {:border-collapse :collapse
            :border-spacing 0}})

(def videojs-resets
  {".vjs-big-play-button, .vjs-loading-spinner, .vjs-text-track-display,
.vjs-poster, .vjs-control-bar, .vjs-play-control, .vjs-error-display,
.vjs-modal-dialog, .vjs-resize-manager"
   {:display "none !important"}})

(defn base-styles
  [gs]
  (merge (resets gs)
         videojs-resets
         {"html" {:height "100%"
                  :width "100%"
                  :box-sizing :border-box
                  :touch-action :manipulation}
          "*" {:-webkit-text-size-adjust "100%"}
          "*, *:before, *:after" {:box-sizing :inherit}
          "body" {:margin (gs [:spacing :p0])
                  :height "100%"}

          "em" {:font-style :italic}

          "strong" {:font-weight (gs [:font-weight :title-10])}

          "#app" {:height "100%"}

          "text" {:font-family (gs [:font-family :open-sans])
                  :color (gs [:colors :gray-scale-500])
                  :font-size (gs [:font-size :body-20])}

          "p" {:margin-top (gs [:spacing :p8])
               :margin-bottom (gs [:spacing :p8])}
          "sup" {:position :relative
                 :top "-0.5em"
                 :font-size "80% !important"}
          "sub" {:position :relative
                 :top "0.5em"
                 :font-size "80% !important"}}))
